import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, LoadingIcon } from '@/components';
import { useWeb3Context } from '@/contexts';
import classnames from 'classnames';
import { useLocales } from '../useLocales';
import styles from './index.module.less';
export const RequestConnection = ({ className, ...rest }) => {
    const t = useLocales();
    const { openConnectionDialog, isConnecting } = useWeb3Context();
    return (_jsxs("div", { className: classnames(className, styles.container), ...rest, children: [_jsx("p", { className: styles.text, children: isConnecting ? t('Connecting') : t('Please connect your wallet.') }), _jsx(Button, { className: styles.button, onClick: openConnectionDialog, disabled: isConnecting, leftIcon: isConnecting ? _jsx(LoadingIcon, {}) : undefined, children: t('Connect Wallet') })] }));
};
